import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import SearchBar from '@/components/feature/SearchBar';

const navItems = [
  { label: '首页', to: '/' },
  { label: '电视剧', to: '/category/电视剧' },
  { label: '花絮', to: '/category/花絮' },
  { label: '搜索', to: '/search' },
  { label: '关于', to: '/about' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.search]);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `whitespace-nowrap font-label text-sm transition-colors ${
      isActive ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'
    }`;

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto w-full max-w-site px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex shrink-0 items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-movie-2-line text-lg" />
            </span>
            <span className="font-heading text-lg font-bold text-foreground-950">
              我妻子的一切
            </span>
          </Link>

          <nav className="hidden items-center gap-7 lg:flex" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} end={item.to === '/'} className={linkClass}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden w-72 xl:block">
            <SearchBar />
          </div>

          <button
            type="button"
            onClick={() => setOpen((prev) => !prev)}
            aria-label="切换导航菜单"
            aria-expanded={open}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
          >
            <i className={`text-xl ${open ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="mx-auto w-full max-w-site space-y-4 px-4 py-4 md:px-6">
            <SearchBar />
            <nav className="flex flex-col" aria-label="移动端导航">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === '/'}
                  className={({ isActive }) =>
                    `border-b border-background-100 py-3 font-label text-sm last:border-b-0 ${
                      isActive ? 'text-primary-500' : 'text-foreground-700'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}